import Card from 'src/models/card/Card'
import Model, { encoders, ID, IsoDateTime, MODEL_LEVEL } from 'src/models/model'
import User from 'src/models/user/User'

export const GIFT_CARD_STATES = {
  DRAFT: 'draft',
  VALID: 'valid',
  VOIDED: 'voided',
  EXPIRED: 'expired'
}
GIFT_CARD_STATES.ALL = _.values(GIFT_CARD_STATES)
GIFT_CARD_STATES.OPTIONS = [GIFT_CARD_STATES.VALID, GIFT_CARD_STATES.VOIDED]

export default class GiftCard extends Model {
  static name = 'GiftCard'

  static versioned = true

  static isExportable = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Promotions]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      state: {
        type: String
      },
      initialValue: {
        type: Number,
        encode: encoders.cents,
        default: 0
      },
      card: {
        type: Card,
        required: false
      },
      uid: {
        type: String,
        default: null,
        output: true
      },
      balance: {
        type: Number,
        default: 0,
        output: true
      },
      recipientUser: {
        type: User,
        encode: encoders.hasOne,
        reference: true
      },
      user: {
        type: User,
        encode: encoders.hasOne,
        reference: true
      },
      circuitId: {
        type: ID,
        default: null,
        output: true
      },
      expiresAt: {
        type: IsoDateTime,
        default: null
      },
      redeemedAt: {
        type: IsoDateTime,
        default: null,
        output: true
      },
      createdAt: {
        type: IsoDateTime,
        default: null,
        output: true
      },
      skipCard: {
        type: Boolean,
        local: true,
        default: false
      }
    }

    this.computed = {
      description () {
        return this.uid
      },
      requiresCard () {
        return !!this.configuration?.currentSite?.giftCardsRequireAssignedCard && !this.card
      },
      cardNumber () {
        return this.card?.humanUid
      }
    }

    this.queries = {
      giftCardByUid: {
        arguments: {
          uid: {
            type: String,
            required: true
          }
        },
        results: {
          giftCard: GiftCard
        }
      }
    }
    this.paginate = true
  }

  validateCardUid (uid) {
    return true
  }
}
